import { NextPage } from 'next'
import { PageLayout } from '../components/layouts/PageLayout'
import { Step, Stepper } from '../components/Stepper'
import {
  CalendarCheck,
  CalendarHeart,
  CreditCard,
  MailSend,
} from '@styled-icons/boxicons-regular'
import Link from 'next/link'
import { Truck } from '@styled-icons/boxicons-solid'

const HowToOrderPage: NextPage = () => {
  return (
    <PageLayout heading="Cómo encargar">
      <Stepper>
        <Step label={'Realizá tu pedido'} icon={<MailSend />}>
          <p>
            Realizá tu consulta por email a{' '}
            <a href="mailto: bluerabbitcorsets@gmail.com">
              bluerabbitcorsets@gmail.com
            </a>{' '}
            o desde la pagina del corset que quieras.
          </p>
          <p>
            Me pondré en contacto con vos para definir tu pedido y presupuesto.
          </p>
          <p>
            No te olvides de leer los{' '}
            <Link href="/terminos-y-condiciones">
              <a>Términos y Condiciones</a>
            </Link>{' '}
            antes realizar tu pedido.
          </p>
        </Step>

        <Step label={'Depositá la seña'} icon={<CreditCard />}>
          <p>
            Una vez confirmado el pedido vas a recibir la ficha de pedido con
            los datos del mismo y los datos para el pago de la seña (el 50% del
            total).
          </p>
          <p>
            Una vez acreditado el dinero ya comenzaré la confección del corset.
          </p>
        </Step>

        <Step label={'De 6 a 8 semanas'} icon={<CalendarHeart />}>
          <p>Los pedidos tardan usualmente entre 6 y 8 semanas.</p>
          <p>
            En caso de necesitar más tiempo te voy a avisar antes de confirmar
            el pedido.
          </p>
        </Step>

        <Step label={'Corset terminado!'} icon={<CalendarCheck />}>
          <p>
            Una vez terminado el corset, te voy a avisar por email para
            coordinar la entrega y el pago del monto restante.
          </p>
          <p>
            Recordá que para poder ser entregado es necesario que esté el pago
            completo.
          </p>
        </Step>

        <Step label={'Recibí tu pedido'} icon={<Truck />}>
          <p>
            Los envíos se realizan por Correo Argentino. Se puede retirar en
            persona en el taller de Villa Adelina, San Isidro.
          </p>
        </Step>
      </Stepper>
    </PageLayout>
  )
}

export default HowToOrderPage
